module.exports = __webpack_public_path__ + "static/media/preview-file.4162dd00.svg";